(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["news-carousel"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded',  function(){
    new Splide(".splide", {
      type: "loop",
      pagination: false,
      autoplay: true,
      interval: 5000,
      speed: 2000
    }).mount();
  });

  } catch(e) { console.error(e); }
})();
})();
